import { render, staticRenderFns } from "./ImpactArea.vue?vue&type=template&id=5941ea1c&scoped=true&"
import script from "./ImpactArea.vue?vue&type=script&lang=js&"
export * from "./ImpactArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5941ea1c",
  null
  
)

export default component.exports